import { render } from "./html-textarea.component.vue?vue&type=template&id=526fc2dc&ts=true"
import script from "./html-textarea.component.ts?vue&type=script&lang=ts"
export * from "./html-textarea.component.ts?vue&type=script&lang=ts"

import exportComponent from "/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__